import React, { JSX } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { ApiActivityType, ChatSenderType } from 'types/types';
import { CopyBubble } from './CopyBubble';
import { getMessageIcon } from './messageStyles';

interface MessageContainerProps {
  type: ApiActivityType | ChatSenderType | 'error';
  metadataView?: React.ReactNode | null;
  messageView?: React.ReactNode | null;
  sx?: SxProps<Theme>;
  copyContent?: string;
}

export const MessageContainer = (props: MessageContainerProps): JSX.Element => {
  const { type, sx, messageView, metadataView, copyContent } = props;
  const icon = getMessageIcon(type);

  return (
    <Box
      className={`Message Message-${type}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        m: 0,
        mt: 1,
        marginBottom: '0px !important',
        gap: 1,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
        {icon !== null && icon}
        {messageView}
      </Box>
      <Box
        flex={{
          display: 'flex',
          position: 'relative',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {copyContent && (
          <CopyBubble content={copyContent} sx={{ position: 'absolute', top: '11px', left: 0 }} />
        )}
        {metadataView}
      </Box>
    </Box>
  );
};
